import React from "react";
import { Card } from "antd";
import { EditOutlined } from "@ant-design/icons";
import CustomButton from "../../../commonComponents/button";
import CustomTypography from "../../../commonComponents/CustomTypography";

/**
 * Reusable DetailsCard component for displaying key-value details
 *
 * @param {string} title - Card title
 * @param {Object} details - Object with key-value pairs to display
 * @param {Array} editableFields - Array of field keys that should have edit buttons
 * @param {Function} onEdit - Callback function when edit button is clicked (receives field key)
 */
const DetailsCard = ({ title, details, editableFields = [], onEdit }) => {
  const styles = {
    body: { padding: "20px 24px", borderRadius: "8px" },
  };

  return (
    <Card style={styles}>
      {title && <CustomTypography.Heading5 className="mb-4">{title}</CustomTypography.Heading5>}

      {/* Render details with simple key-value pairs */}
      {Object.entries(details).map(([key, value], index) => (
        <div className="my-4 last:my-0" key={index}>
          <div className="flex items-center mb-1">
            <CustomTypography.BodySmall
              strong
              className="!text-[#00000080] !text-xs !text-semibold"
            >
              {key}
            </CustomTypography.BodySmall>

            {/* Show edit button if field is in editableFields array */}
            {editableFields.includes(key) && (
              <CustomButton
                type="text"
                icon={<EditOutlined className="icon-color text-sm" />}
                className="p-0 h-auto"
                handleClick={() => onEdit && onEdit(key)}
              />
            )}
          </div>
          <div>
            {/* Show value or "Not assigned" */}
            {value ? (
              <span className="text-black-88 font-normal text-sm">{value}</span>
            ) : (
              <span className="text-black-45 font-normal text-sm italic">--</span>
            )}
          </div>
        </div>
      ))}
    </Card>
  );
};

export default DetailsCard;
